<div class="modal-content">
  <div class="modal-header">
    <span class="modal-title" id="modal-title"> Bulk Search </span>
  </div>
  <div class="modal-body">
    <div *ngIf="showUploadModal">
      <div class="upload-container">
        <div
          class="drop-zone"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
        >
          <input
            type="file"
            #fileInput
            accept=".xlsx,.csv"
            (change)="onFileSelect($event)"
            hidden
          />
          <div class="icon">
            <img
              src="assets/images/drag&drop.svg"
              alt="upload"
              class="btn-icon-svg"
            />
          </div>
          <label for="fileDropRef" class="dropref-btn"
            >Drag & Drop your files</label
          >
          <div *ngIf="file">
            <div class="dropext">Selected File: {{ file.name }}</div>
          </div>

          <div
            class="dropzone"
            appFileUpload
            (filesChangeEmiter)="onFileChange($event)"
          >
            <input
              hidden
              type="file"
              #fileDropRef
              id="fileDropRef"
              (change)="getFileName($event)"
            />
            <div class="dropext">Accepted file type .xlsx only</div>
            <label for="fileDropRef" class="dropref">
              <img
                src="assets/images/upload.svg"
                alt="upload"
                class="btn-icon-svg"
              />
              Upload File
            </label>
            <div>
              <i
                class="fa fa-cloud-upload fa-2x"
                aria-hidden="true"
                style="color: #879baf; margin-top: 9px"
              ></i>
            </div>
          </div>
        </div>
      </div>
      <div class="template">
        <div class="btndt">
          <span (click)="downloadTemplate()"> Download Template </span>

          <mat-icon
            matTooltip="Please use this template to perform bulk search with entering multiple searching criterias into rows and upload."
            style="margin-top: 1px"
            aria-label="Button that displays a tooltip when focused or hovered over"
            aria-hidden="true"
          >
            info
          </mat-icon>
        </div>
      </div>
    </div>

    <div class="row col file-center" *ngIf="fileName !== ''">
      <div class="fileItem margin">
        <button
          class="icon-button col-sm-12 fileItemIconDiv"
          (click)="deleteFile()"
        >
          <i class="bi bi-trash icon fs-5 btn-icon"></i>
        </button>
        <div class="col-sm-12 fileItemText">
          <span>{{ fileName }}</span>
        </div>
      </div>
    </div>
    <div class="row col">
      <div class="col-sm-12 error-box" *ngIf="!excelValidationResult.isValid">
        <ul class="file-errors">
          <li *ngFor="let data of excelValidationResult.errorMsg">
            <span class="danger">{{ data }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="modal-footer mdf-pd0">
    <button
      type="button"
      class="cancel-btn"
      (click)="activeModal.close('close')"
    >
      Cancel
    </button>
    <button
      class="submit-btn"
      (click)="onUpload()"
      [disabled]="submitButtonDisabled"
    >
      Submit
    </button>
  </div>
</div>
